/* eslint-disable @typescript-eslint/no-unused-vars */
import { SternumTheme } from '@sternum/theme';
import { CheckboxTheme } from '@sternum/ui';

import { Colors } from '../constants';

export function SBOMDarkCheckboxTheme(theme: SternumTheme): Partial<CheckboxTheme.CheckboxTheme> {
  return {
    width: '16px',
    height: '16px',

    borderRadius: '4px',
    borderColor: Colors.BrandBlueLightest,
    hoverBorderColor: Colors.BrandBlue,
    disabledBorderColor: Colors.Grey,

    inactiveBackground: Colors.BrandBlueLightest,
    activeBackground: Colors.BrandBlue,
    disabledActiveBackground: Colors.Grey,
    disabledInctiveBackground: Colors.Grey,

    checkIconSize: 8,
    indeterminateIconSize: 8,

    iconColor: Colors.White,
  };
}
